import React from 'react';
import {useRecoilValue} from 'recoil';

import {scoreState} from './atom';

const Score = () => {
    const score = useRecoilValue(scoreState);

    return (
        <div className="score">
            <p><span className='number'>{`${score < 0 ? 0 : score}`}</span> pts</p>
        </div>
    );
};

export default React.memo(Score);
